import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ProductPage from '../components/product-page';
import * as catalogActions from '../redux/actions/catalogActions';
import * as depositActions from '../redux/actions/depositActions';

const mapStateToProps = state => {
  return { catalog: state.catalogReducer };
};

const mapDispatchToProps = dispatch => {
  return { actions: bindActionCreators({ ...catalogActions, ...depositActions }, dispatch) };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductPage);
